import { CommonHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const putWorkFlowData = (workflowId, workflowObj, state, setState) => {
  if (state.isSaving === false && !state.message) {
    let newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const workflowIdForUrl = workflowId ? encodeURIComponent(workflowId) : 'NaN';
    const url = `/Workflow/${workflowIdForUrl}`;
    CommonHttpHelper(url, 'PUT', workflowObj)
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isSaving: false,
            isSaved: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  };
};

export default putWorkFlowData;